// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { getEvent } from "./Event";
import { ControlMode, WebPageComponent } from "./WebSite.Page.Component";

export class BiStateField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.valueField = query.getChild(WithTagName("INPUT"));
    this.trueSelector = query.getChild(WithClass("TrueSelector"));
    this.falseSelector = query.getChild(WithClass("FalseSelector"));

    this.falseState = new HtmlClassSwitch(this.element, "False");
    this.falseState.setStatus(this.valueField.value == "False");

    this.trueState = new HtmlClassSwitch(this.element, "True");
    this.trueState.setStatus(this.valueField.value == "True");
  }

  biStateClicked(event, biState) {
    this.trueState.setStatus(biState);
    this.falseState.setStatus(!biState);

    if (biState)
      this.valueField.value = "True";
    else
      this.valueField.value = "False";
  }

  attachEventHandlers() {
    if (this.mode === ControlMode.edit) {
      this.trueSelector.onclick = (event) => { this.biStateClicked(getEvent(event), true); };
      this.falseSelector.onclick = (event) => { this.biStateClicked(getEvent(event), false); };
    }
  }
}

interactivityRegistration.register("BiState", function (element) { return new BiStateField(element); });
